var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.buttonWrapperStyle)},[(_vm.isLink)?_c('a',{staticClass:"tw-border-darkblue btn tw-cursor-pointer tw-text-black",class:{
      [`btn--${this.size}`]: true
    },attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('button',{class:[_vm.classes, 'tw-cursor-pointer'],style:(_vm.style),attrs:{"id":_vm.id,"type":"button"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }